import { EducatorInterface } from "../../../common/interfaces/EducatorInterface";
import { Dispatch } from "redux";
import { TertiaryTableRow } from "@hatch-digital-nl/abs-storybook/legacy";

interface EmployeeCertificateDataRow {
    educatorData: EducatorInterface[];
    dispatch: Dispatch;
}

export const mapEmployeeCertificateDataToRows = (
    props: EmployeeCertificateDataRow,
): TertiaryTableRow[] => {
    const { educatorData } = props;

    return educatorData.map((educator) => {
        return {
            id: educator.id,
            columns: [
                { value: educator.name },
                ...(educator.website_url
                    ? [
                          {
                              value: educator.website_url,
                              onLinkClick: () =>
                                  window.open(educator.website_url),
                          },
                      ]
                    : [{ value: "-" }]),
            ],
        };
    });
};
